import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "Home",
      enterCLass: "animate__animated animate__fadeInLeft",
      leaveClass: "animate__animated animate__fadeOutRight",
    },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
    meta: {
      title: "About Me",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  // {
  //   path: "/services",
  //   name: "services",
  //   component: () => import("../views/Services.vue"),
  //   meta: {
  //     title: "My Services",
  //     enterCLass: "animate__animated animate__fadeInLeft",
  //     leaveClass: "animate__animated animate__fadeOutRight",
  //   },
  // },
  {
    path: "/certificates",
    name: "certificates",
    component: () => import("../views/Certificates.vue"),
    meta: {
      title: "Certificates",
      enterCLass: "animate__animated animate__fadeInLeft",
      leaveClass: "animate__animated animate__fadeOutRight",
    },
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/Contact.vue"),
    meta: {
      title: "Contact Me",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works",
    name: "works",
    component: () => import("../views/Work.vue"),
    meta: {
      title: "My Works",
      enterCLass: "animate__animated animate__fadeInLeft",
      leaveClass: "animate__animated animate__fadeOutRight",
    },
  },
  {
    path: "/works/todo",
    name: "todo",
    component: () => import("../views/projects/Todo.vue"),
    meta: {
      title: "Todo App",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/projectManagement",
    name: "project_management",
    component: () => import("../views/projects/ProjectManagement.vue"),
    meta: {
      title: "Project Management App",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/restaurant",
    name: "restaurant",
    component: () => import("../views/projects/Restaurant.vue"),
    meta: {
      title: "Restaurant App",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/weather",
    name: "weather",
    component: () => import("../views/projects/Weather.vue"),
    meta: {
      title: "Weather App",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/watch",
    name: "watch",
    component: () => import("../views/projects/Watch.vue"),
    meta: {
      title: "Watches Store",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/quran",
    name: "quran",
    component: () => import("../views/projects/Quran.vue"),
    meta: {
      title: "Quran Player",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/clothes",
    name: "clothes",
    component: () => import("../views/projects/Ecommerce.vue"),
    meta: {
      title: "Clothes Store",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/football-transfers",
    name: "transfers",
    component: () => import("../views/projects/FootballTransfers.vue"),
    meta: {
      title: "Football 2022 transfers",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/remal",
    name: "ramal",
    component: () => import("../views/projects/Remal.vue"),
    meta: {
      title: "Remal Website",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/restaurant2",
    name: "rest",
    component: () => import("../views/projects/Rest.vue"),
    meta: {
      title: "Full-Stack Restaurant",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/hiring-agency",
    name: "gsap",
    component: () => import("../views/projects/GSAP.vue"),
    meta: {
      title: "GSAP & Scroll Animation website",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/emloassess",
    name: "elmoassess",
    component: () => import("../views/projects/ElMoassess.vue"),
    meta: {
      title: "El-Moassess Educational platform",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/works/hardware-market",
    name: "hardware",
    component: () => import("../views/projects/Hardware.vue"),
    meta: {
      title: "Hardware Market",
      enterCLass: "animate__animated animate__fadeInRight",
      leaveClass: "animate__animated animate__fadeOutLeft",
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("../views/NotFound.vue"),
    meta: {
      title: "404 Not Found",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | Mohamed El-Sayed`;
  next();
});
export default router;
